/**
 * Gemeinsame Breakpoints (px). Vorher fünf unkoordinierte Werte (640/720/767/820/900).
 * In SCSS stehen dieselben Werte als $bp-phone / $bp-tablet / $bp-desktop bereit
 * (Injection in vite.config.ts), im TS über useBreakpoint().
 */
export const BREAKPOINTS = {
  phone: 640,
  tablet: 900,
  desktop: 1200,
} as const

export type BreakpointName = keyof typeof BREAKPOINTS

export function mediaMax(bp: BreakpointName): string {
  return `(max-width: ${BREAKPOINTS[bp]}px)`
}

export function matchesMax(bp: BreakpointName): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(mediaMax(bp)).matches
}

export function isCoarsePointer(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia('(pointer: coarse)').matches
}
